import { ClientAreaApiClient } from 'common/api/autogenerated/client-area';

import { routes } from '../../../routes/routes.constants';
import svgIcons from '../../svgIcons';
import { SidebarItemType } from './types';

const clientAreaApiClient = new ClientAreaApiClient({
  BASE: '/client-area',
  WITH_CREDENTIALS: true,
});

export const getRewards = () => clientAreaApiClient.loyaltyProgram.getApiLoyaltyProgramRewards();

export enum ClientAreaPages {
  NOTIFICATIONS = 'notifications',
  ORDERS = 'orders',
  REWARDS = 'rewards',
  REFERAL = 'referal',
  ABOUT = 'about',
  SETTINGS = 'settings',
  HELP = 'help',
}

type SidebarItemsType = {
  top: SidebarItemType[];
  bottom: SidebarItemType[];
};

type SidebarConstantsType = {
  isAuthenticated?: boolean;
  isDesktop: boolean;
  isMobile: boolean;
};

export const getSidebarItems = ({ isAuthenticated, isMobile }: SidebarConstantsType): SidebarItemsType => ({
  top: [
    {
      label: 'notifications',
      path: routes.getNotificationsPage(),
      icon: svgIcons.MenuNotifications(),
      iconActive: svgIcons.MenuNotificationsActive(),
      disabled: true,
      hide: true,
      counter: (translate) => translate.toText('mobile:sidebar:coming-soon'),
    },
    {
      label: 'token-presale',
      path: routes.getTokenPresalePage(),
      icon: svgIcons.XboToken(),
      iconActive: svgIcons.XboToken(),
      skipAuthCheck: true,
      feature: 'tokenPresaleEnabled',
      highlighted: true,
      tag: (translate) => translate.toText('mobile.sidebar.hint.token-presale'),
    },
    {
      label: 'payment-card',
      path: routes.getPaymentCardPage(),
      icon: isMobile ? svgIcons.XboCardMobActive() : svgIcons.XboCard(),
      iconActive: isMobile ? svgIcons.XboCardMobActive() : svgIcons.XboCardDeskActive(),
      skipAuthCheck: true,
      feature: 'paymentCardEnabled',
      tag: (translate) => translate.toText('mobile.sidebar.tag.payment-card'),
      // counter: () => '$20,500.54',
    },
    {
      label: 'rewards',
      path: routes.getRewardsPage(),
      icon: svgIcons.MenuRewards(),
      getNotificationState: () => getRewards().then((resp) => Boolean(resp.rewards?.length)),
      iconActive: svgIcons.MenuRewardsActive(),
    },
    {
      label: 'withdrawal-address',
      path: routes.getWithdrawalAddressPage(),
      icon: svgIcons.MenuWithdrawalAddress(),
      iconActive: svgIcons.MenuWithdrawalAddressActive(),
    },
    {
      label: 'statement',
      path: routes.getStatementPage(),
      hide: isMobile,
      icon: svgIcons.MenuStatement(),
      iconActive: svgIcons.MenuStatementActive(),
    },
    {
      label: 'referal',
      path: routes.getReferalPage(),
      icon: svgIcons.MenuReferal(),
      iconActive: svgIcons.MenuReferalActive(),
    },
    {
      label: 'help',
      path: routes.getContactUsPage(),
      skipAuthCheck: true,
      icon: svgIcons.MenuHelp(),
      iconActive: svgIcons.MenuHelpActive(),
    },
  ],
  bottom: [
    {
      label: 'security',
      path: routes.getSecurityPage(),
      hide: !isAuthenticated,
      icon: svgIcons.MenuSecurity(),
      iconActive: svgIcons.MenuSecurityActive(),
    },
    {
      label: 'cryptopayx',
      path: routes.getCryptoPayPage(),
      hide: !isAuthenticated || !isMobile,
      icon: svgIcons.CryptoPayX(),
      iconActive: svgIcons.CryptoPayX(),
    },
    {
      label: 'about',
      target: '_blank',
      external: true,
      path: routes.getAboutUsPage(),
      skipAuthCheck: true,
      icon: svgIcons.MenuInfo(),
      iconActive: svgIcons.MenuInfoActive(),
    },
  ],
});
